var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.026 14.6367C8.65356 15.1063 7.16996 15.1212 5.78866 14.6792C4.40737 14.2372 3.1996 13.3612 2.33913 12.1771C1.47866 10.993 1.00985 9.56197 1.00015 8.08984C0.99046 6.61772 1.44038 5.18041 2.28518 3.98474C3.12998 2.78906 4.32611 1.89665 5.70146 1.43591C7.07681 0.975173 8.56048 0.969861 9.93899 1.42074C11.3175 1.87161 12.5198 2.75544 13.3728 3.94504C14.2259 5.13463 14.6858 6.56868 14.6863 8.04084C14.6642 8.60513 14.597 9.16666 14.4853 9.71988",
    stroke: "white",
    strokeWidth: 0.875008
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45584 13.3438C8.96354 13.9124 8.42385 14.4367 7.84277 14.9109",
    stroke: "white",
    strokeWidth: 0.875008
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84277 1.00269C9.68996 2.64337 10.8329 4.95325 11.0276 7.43903C11.0676 7.89026 11.0759 8.34382 11.0524 8.79626",
    stroke: "white",
    strokeWidth: 0.875008
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84385 1.00269C6.84163 1.89075 6.03647 2.98519 5.48172 4.21348C4.92696 5.44178 4.63527 6.77589 4.62598 8.12744C4.62598 12.6609 6.62992 14.0041 7.83559 14.9108",
    stroke: "white",
    strokeWidth: 0.875008
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.88965 4.61255H13.8307",
    stroke: "white",
    strokeWidth: 0.875008
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84277 1V14.9109",
    stroke: "white",
    strokeWidth: 0.875008
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07617 11.7712H9.23037",
    stroke: "white",
    strokeWidth: 0.875008
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.12773L14.6863 7.95703",
    stroke: "white",
    strokeWidth: 0.875008
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7806 14.995L15 13.7525L12.7979 11.5138L14.0503 10.6994C14.0686 10.6885 14.0831 10.6721 14.092 10.6526C14.1009 10.633 14.1038 10.6112 14.1002 10.5899C14.0966 10.5687 14.0868 10.549 14.072 10.5336C14.0572 10.5182 14.0381 10.5077 14.0173 10.5035L9.80847 9.50171C9.79109 9.49811 9.7731 9.49894 9.75612 9.50414C9.73913 9.50933 9.72367 9.51873 9.71113 9.53148C9.69859 9.54423 9.68935 9.55994 9.68424 9.57721C9.67913 9.59448 9.67831 9.61277 9.68185 9.63044L10.5957 13.9904C10.6001 14.0116 10.6106 14.0309 10.6259 14.046C10.6412 14.0612 10.6605 14.0713 10.6814 14.0752C10.7024 14.0791 10.724 14.0766 10.7436 14.068C10.7631 14.0593 10.7797 14.045 10.7912 14.0267L11.5784 12.7563L13.7806 14.995Z",
    stroke: "white",
    strokeWidth: 0.875008
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.58ac5bf8a3ff57ba080bd3cd0419562a.svg";
export { ForwardRef as ReactComponent };